import { render, staticRenderFns } from "./WideLayout.vue?vue&type=template&id=c83d5872&scoped=true"
import script from "./WideLayout.vue?vue&type=script&lang=js"
export * from "./WideLayout.vue?vue&type=script&lang=js"
import style0 from "./WideLayout.vue?vue&type=style&index=0&id=c83d5872&prod&lang=css"
import style1 from "./WideLayout.vue?vue&type=style&index=1&id=c83d5872&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83d5872",
  null
  
)

export default component.exports